import Papa from 'papaparse';

const downloadCSV = args => {
  const filename = args.filename || 'export.csv';
  const columns = args.columns || null;
  const mimeType = args.mimeType || 'application/octet-stream';

  const csv = Papa.unparse({ data: args.data, fields: columns });
  if (csv == null) return;

  const blob = new Blob([csv], { type: mimeType });

  const a = document.createElement('a');

  if (navigator.msSaveBlob) {
    // IE10
    navigator.msSaveBlob(blob, filename);
  } else if (URL && 'download' in a) {
    // html5 A[download]
    a.href = URL.createObjectURL(blob);
    a.setAttribute('download', filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    window.location.href = `data:application/octet-stream,${encodeURIComponent(csv)}`; // only this mime type is supported
  }
};

export default downloadCSV;
